/* tslint:disable */
import { LocaleCsCZ } from './cs-CZ';
import { LocaleDaDK } from './da-DK';
import { LocaleDeAT } from './de-AT';
import { LocaleDeCH } from './de-CH';
import { LocaleDeDE } from './de-DE';
import { LocaleEnCA } from './en-CA';
import { LocaleEnGB } from './en-GB';
import { LocaleEnIE } from './en-IE';
import { LocaleEnUS } from './en-US';
import { LocaleEsES } from './es-ES';
import { LocaleFiFI } from './fi-FI';
import { LocaleFrBE } from './fr-BE';
import { LocaleFrCA } from './fr-CA';
import { LocaleFrCH } from './fr-CH';
import { LocaleFrFR } from './fr-FR';
import { LocaleFrLU } from './fr-LU';
import { LocaleItIT } from './it-IT';
import { LocaleNbNO } from './nb-NO';
import { LocaleNlBE } from './nl-BE';
import { LocaleNlNL } from './nl-NL';
import { LocalePlPL } from './pl-PL';
import { LocaleSkSK } from './sk-SK';
import { LocaleSvSE } from './sv-SE';
/* tslint:enable */

export class TranslationCollection
{
  public static getTranslationConfig(locale: string): any
  {
    switch (locale) {
      case 'cs-CZ': return new LocaleCsCZ();
      case 'da-DK': return new LocaleDaDK();
      case 'de-AT': return new LocaleDeAT();
      case 'de-CH': return new LocaleDeCH();
      case 'de-DE': return new LocaleDeDE();
      case 'en-CA': return new LocaleEnCA();
      case 'en-GB': return new LocaleEnGB();
      case 'en-IE': return new LocaleEnIE();
      case 'en-US': return new LocaleEnUS();
      case 'es-ES': return new LocaleEsES();
      case 'fi-FI': return new LocaleFiFI();
      case 'fr-BE': return new LocaleFrBE();
      case 'fr-CA': return new LocaleFrCA();
      case 'fr-CH': return new LocaleFrCH();
      case 'fr-FR': return new LocaleFrFR();
      case 'fr-LU': return new LocaleFrLU();
      case 'it-IT': return new LocaleItIT();
      case 'nb-NO': return new LocaleNbNO();
      case 'nl-BE': return new LocaleNlBE();
      case 'nl-NL': return new LocaleNlNL();
      case 'pl-PL': return new LocalePlPL();
      case 'sk-SK': return new LocaleSkSK();
      case 'sv-SE': return new LocaleSvSE();
      default: return new LocaleDeDE();
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/translation.collection.ts